package org.vreo.devicehub.features.vrmOutput.domain.models

import kotlinx.serialization.Serializable

/**
 * Time zone display data class for holding data of the individual time zone
 *
 * @property id identifier of the time zone
 * @property region region of the time zone
 * @property city city of the time zone
 * @property offset offset of the time zone
 */
@Serializable
data class TimeZoneDisplay(
    val id: String,
    val region: String,
    val city: String,
    val offset: Double
) {
    override fun toString(): String {
        val formatedOffset = if (offset >= 0) { "+$offset" } else { "$offset" }
        return "$region, $city (UTC $formatedOffset)"
    }
}